export default {"src":"/_next/static/media/aysoft_logo.e241d36d.svg","height":425,"width":1311,"blurWidth":0,"blurHeight":0};